// Leo accounting (invoice) API, served by profile-management under /api/accounting.
const API_BASE_URL = process.env.REACT_APP_BASE_URL || ''

export function accountingUrl(path: string) {
  return `${API_BASE_URL}/api/accounting${path}`
}

export async function accountingRequest<T = any>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(accountingUrl(path), init)
  if (response.status === 204) return undefined as unknown as T
  const body = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(body.message || 'Request failed')
  return body as T
}

export function jsonInit(method: string, payload: unknown): RequestInit {
  return {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }
}

export function formatMoney(value: unknown, currency?: string) {
  const number = Number(value) || 0
  try {
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency || 'CAD' }).format(number)
  } catch {
    return `${number.toFixed(2)} ${currency || ''}`.trim()
  }
}

export function when(value: unknown) {
  if (!value) return ''
  return String(value).replace('T', ' ').slice(0, 16)
}

export function round2(value: unknown) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100
}
